<template>
  <div>
    <van-nav-bar left-arrow title="我的推荐餐厅" @click-left="back" />
    <div class="content">
      <DropdownMenu @queryList="getList" />
      <div class="container">
        <div v-if="lists.selected.length">
          <div class="shop-title">已选餐厅</div>
          <div v-for="(item,index) in lists.selected" :key="index+100" @click="shopDetail(item)">
            <van-panel :title="item.name" :status="item.shopStatusTxt">
              <van-row>
                <van-col span="6">
                  <van-image width="65" height="65" :src="item.imgThumbnail" />
                </van-col>
                <van-col span="16">
                  <div>{{item.categoryVal||'不详'}}</div>
                  <div>地址：{{item.address||'不详'}}</div>
                </van-col>
              </van-row>
            </van-panel>
            <div class="block-waiper"></div>
          </div>
        </div>
        <div v-if="lists.customed.length">
          <div class="shop-title">手工录入餐厅</div>
          <div v-for="(item,index) in lists.customed" :key="index">
            <van-panel :title="item.name" :status="item.shopStatusTxt">
              <div>电话：{{item.tel}}</div>
              <div>地址：{{item.address}}</div>
            </van-panel>
            <div class="block-waiper"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { httpService } from "@/service/httpService.js";
import DropdownMenu from "@/components/ishop/DropdownMenu.vue";
export default {
  data() {
    return {
      lists: {
        selected: [],
        customed: []
      }
    };
  },
  components: { DropdownMenu },
  methods: {
    shopDetail(item) {
      this.$store.commit("setValue", {
        shopDetail: item
      });
      this.$router.push({ name: "shopDetail" });
    },
    back() {},
    getList(data) {
      let params = {
        ...data,
        channel: "app",
        itemType: 5
      };
      httpService.queryMyShops(params).then(res => {
        if (res && res.success) {
          this.lists = res.content.data;
        }
      });
    }
  },
  mounted() {
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.van-panel__content {
  padding: 15px;
}
.shop-title {
  padding: 8px 15px;
}
.container {
  position: absolute;
  top: 50px;
  width: 100%;
  bottom: 0;
  overflow: scroll;
}
</style>
